export const Config = {
   Currency: '$',
   Single_Market_Price: '129',
   ProSubscriptionPrice: '359',
   API_URL: '/api',
   Period: 'Month',
   ProLookupKey: 'rvpark_unlimited',
   mapBox_Token: "pk.eyJ1IjoiYWdnaW50ZWwtbWFwYm94IiwiYSI6ImNsMDE2bTlrNDAxYW4zZnBhcTltN3B1M20ifQ.j4ELBd-KiHX1k9kQRobc4Q",
   LookupKey: "rvpark_singlereport" ,
   PhoneNumber: '(800) 377-3098',
   supportEmail: 'info@rvparkiq.com',
   ContactUrl: "https://rvparkiq.com/contact",
   ListRVSignInUrl: "https://rvparkiq.com",
   googleMapsApiKey : "AIzaSyBefQx5zXoL6NexRoEv1m2OIdqmBPdfTQ8"
  }
  